import React from 'react'
import fiveHundred from 'src/assets/images/500.svg'
import './error.scss'

export function InternalServerError() {
    return <Error title="Internal server error" errorCode="500" />
}

export const NotAuthorized = () => {
    return <Error title="Unauthorized" errorCode="401" />
}

function Error(props) {
    return (
        <div className={'page-body error-page'}>
            <h1 className={'error-title'}>{props.title}</h1>
            <p className={'error-status fz-8 stix-text-center'}>
                {props.errorCode}
            </p>
            <div
                style={{
                    maxWidth: '30%',
                    margin: 'auto',
                }}
            >
                <img
                    src={fiveHundred}
                    alt={'An error has occurred while processing your request.'}
                />
            </div>
        </div>
    )
}
